/**
 * Studio chrome catalogs, auto-assembled from the JSON tree via Vite's glob
 * import (Studio is a Vite app — no generated barrel needed; the flock just
 * drops locales/<lng>/<ns>.json files and they are picked up at build). The
 * `errors` namespace maps server error CODES → localised messages, so the
 * backend never ships display text.
 */

import type { Resource } from "@archlang/i18n";

const modules = import.meta.glob("./locales/*/*.json", { eager: true }) as Record<
  string,
  { default: Record<string, unknown> }
>;

const built: Record<string, Record<string, Record<string, unknown>>> = {};
const nsSet = new Set<string>();

for (const [path, mod] of Object.entries(modules)) {
  const m = /\.\/locales\/([^/]+)\/([^/]+)\.json$/.exec(path);
  if (!m) continue;
  const [, loc, ns] = m;
  (built[loc!] ??= {})[ns!] = mod.default;
  nsSet.add(ns!);
}

export const STUDIO_NAMESPACES = [...nsSet].sort();
export const STUDIO_DEFAULT_NS = "common";
export const resources = built as Resource;
